import { TypeSimpleComponent } from "enum";
import { ComponentState } from "types/Component";

function htmlToPlainText(value: unknown): string {
  if (value == null || value === "") {
    return "";
  }
  const str = String(value);
  if (typeof document !== "undefined") {
    const el = document.createElement("div");
    el.innerHTML = str;
    return el.textContent?.replace(/\s+/g, " ").trim() ?? "";
  }
  return str
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function getAutocompleteClipboardValue(value: unknown): string {
  if (value == null || value === "") {
    return "";
  }
  if (typeof value === "object") {
    const item = value as { label?: string; id?: unknown };
    if (item.label != null && item.label !== "") {
      return String(item.label);
    }
    if (item.id != null) {
      return String(item.id);
    }
    return "";
  }
  return String(value);
}

function getProcessusLinkClipboardValue(compo?: ComponentState): string {
  return compo?.options?.label != null ? String(compo.options.label) : "";
}

export function formatCellValueForClipboard(
  value: unknown,
  typeCompo: string | undefined,
  formatValue: (value: unknown) => string,
  compo?: ComponentState,
): string {
  if (typeCompo == null) {
    return value != null ? String(value) : "";
  }

  switch (typeCompo) {
    case TypeSimpleComponent.AUTO_COMPLETE:
      return getAutocompleteClipboardValue(value);
    case TypeSimpleComponent.AUTO_COMPLETE_VIEW:
    case TypeSimpleComponent.AUTO_COMPLETE_VIEW_FREE:
      return formatValue(value) || getAutocompleteClipboardValue(value);
    case TypeSimpleComponent.OEL:
    case TypeSimpleComponent.EDITOR:
    case TypeSimpleComponent.STATIC_HTML:
    case TypeSimpleComponent.LINK:
      return htmlToPlainText(value);
    case TypeSimpleComponent.PROCESSUS_LINK:
      return getProcessusLinkClipboardValue(compo);
    default:
      if (value != null && typeof value === "object") {
        return getAutocompleteClipboardValue(value);
      }
      return formatValue(value) ?? "";
  }
}
